import { useDispatch, useSelector } from 'react-redux';
import EmployeeDisplayPreferencesSettings from '../GlobalSetup-EmployeeDisplayPreferences';
import ManagersArchiveSettings from '../GlobalSetup-ManagersArchiveSettings';
import EmployeesArchiveSettings from '../GlobalSetup-EmployeesArchiveSettings';
import DatasetFieldLabelsOverride from '../GlobalSetup-DatasetFieldLabelsOverride';
import OrgJobPathCostCenterConfig from '../GlobalSetup-OrgJobPathCostCenterConfig';
import './GlobalSetupForm.scss';
import ActionBar from '../ActionBar';
import { UPDATE_GLOBAL_SETUP, updateGlobalSetup } from '../../store/globalSetup';

/**
 * @param {{
 *  isDisabled?: boolean;
 *  isGlobalSetupLoaded: boolean;
 *  globalSetups: GlobalSetup.GlobalSetup;
 *  globalSetupsToReset: GlobalSetup.GlobalSetup;
 * }} param0
 */
const GlobalSetupForm = ({
    isGlobalSetupLoaded,
    globalSetups,
    isDisabled,
    globalSetupsToReset
}) => {
    let i = 0;
    const dispatch = useDispatch();
    const resetAction = {
        type: UPDATE_GLOBAL_SETUP,
        payload: globalSetupsToReset,
    };
    const onSave = () => dispatch(updateGlobalSetup(globalSetups));
    const onReset = () => dispatch(resetAction);
    const isGlobalSetupEmployeeDisplayPreferenceAvailable = useSelector((/** @type {ShiftBidding.ShiftBiddingStore} */state) => state.publicConfigs.isGlobalSetupEmployeeDisplayPreferenceAvailable);
    const isDataSetManagerPageExist = useSelector((/** @type {ShiftBidding.ShiftBiddingStore} */state) => state.publicConfigs.isDataSetManagerPageExist);
    const isUseCostCenterAsOrgJobPath = useSelector((/** @type {ShiftBidding.ShiftBiddingStore} */state) => state.publicConfigs.isUseCostCenterAsOrgJobPath);

    return (
        <div className="global-setup-form">
            <ManagersArchiveSettings
                isLoading={!isGlobalSetupLoaded}
                globalSetups={globalSetups}
                step={++i}
            />
            <EmployeesArchiveSettings
                isLoading={!isGlobalSetupLoaded}
                globalSetups={globalSetups}
                step={++i}
            />
            {isGlobalSetupEmployeeDisplayPreferenceAvailable && (
                <EmployeeDisplayPreferencesSettings
                    isDisabled={isDisabled || false}
                    globalSetups={globalSetups}
                    globalSetupsToReset={globalSetupsToReset}
                    isLoading={!isGlobalSetupLoaded}
                    step={++i}
                />
            )}
            {isDataSetManagerPageExist && (
                <DatasetFieldLabelsOverride
                    isLoading={!isGlobalSetupLoaded}
                    globalSetups={globalSetups}
                    step={++i}
                />
            )}
            {isUseCostCenterAsOrgJobPath && (
                <OrgJobPathCostCenterConfig
                    isLoading={!isGlobalSetupLoaded}
                    globalSetups={globalSetups}
                    globalSetupsToReset={globalSetupsToReset}
                    step={++i}
                />
            )}
            <ActionBar
                isDisabled={isDisabled || false}
                isLoading={!isGlobalSetupLoaded}
                onSave={onSave}
                onReset={onReset}
                className="action-buttons-container"
            />
        </div>
    );
};

export default GlobalSetupForm;
